const setting = {
  api_endpoint: 'https://morimoritor-prod-api.morimoritor.enforesters.com',
  stripe_public_key:
    'pk_live_51I3hVyIwpnDb34yXEdUJoS8a0iT1WAuKUh99o7Z8HaraWhLTvDaN2L54QbPfkeWXtCT2mRtAdkMki0LNjlp4RUGW00U6hyYM3c',
};

export default setting;
